import { useMemo } from 'react';
import type { FsnbWorkCardLine } from '@shared/api';
import { fmtNum } from '@shared/lib/smetaLabels';
import { ROLE_ORDER, priceText, roleTitle } from '../../normBaseLabels';
import { lineName, lineUnit } from '../helpers';
import { Grid, Muted, TableWrap } from '../styles';

export function GroupRows({
  title,
  items,
  onOpenResource,
}: {
  title: string;
  items: FsnbWorkCardLine[];
  onOpenResource?: (source: string, code: string) => void;
}) {
  return (
    <>
      <tr className="group">
        <td colSpan={5}>{title}</td>
      </tr>
      {items.map((l, i) => {
        const inCatalog = Boolean(l.catalog_name);
        return (
          <tr
            key={`${l.resource_code}-${i}`}
            className={inCatalog && onOpenResource ? 'clickable' : undefined}
            onClick={
              inCatalog && onOpenResource
                ? () => onOpenResource('fsbc', l.resource_code)
                : undefined
            }
          >
            <td className="code">{l.resource_code}</td>
            <td>{lineName(l)}</td>
            <td>{lineUnit(l)}</td>
            <td className="num">{l.quantity === null ? 'по проекту' : fmtNum(l.quantity)}</td>
            <td>{inCatalog ? priceText(l.cost, l.price_details) : '—'}</td>
          </tr>
        );
      })}
    </>
  );
}

/** Состав нормы, сгруппированный как таблица нормы в сборнике. */
export function ResourcesTable({
  lines,
  onOpenResource,
}: {
  lines: FsnbWorkCardLine[];
  onOpenResource?: (source: string, code: string) => void;
}) {
  const groups = useMemo(
    () =>
      ROLE_ORDER.map((role) => ({ role, items: lines.filter((l) => l.role === role) })).filter(
        (g) => g.items.length > 0,
      ),
    [lines],
  );
  if (lines.length === 0) return <Muted>Состав ресурсов в норме не указан.</Muted>;
  return (
    <TableWrap>
      <Grid>
        <thead>
          <tr>
            <th>Шифр</th>
            <th>Ресурс</th>
            <th>Ед. изм.</th>
            <th className="num">Расход</th>
            <th>Цена ФСБЦ</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((g) => (
            <GroupRows
              key={g.role}
              title={roleTitle(g.role)}
              items={g.items}
              onOpenResource={onOpenResource}
            />
          ))}
        </tbody>
      </Grid>
    </TableWrap>
  );
}
